<template>
  <div class="container-center-horizontal">
    <div class="u1089u1090u1088u1072u1085u1080u1094u1072-u1076u1086u1084u1072u1096u1082u1080 screen">
      <div class="x-34">
        <view602 />
        <div class="view-161">
          <div class="rectangle-26"></div>
          <div class="view-162">
            <div class="rectangle-27"></div>
            <div class="view-163">
              <div class="view-164">
                <div class="rectangle-32"></div>
                <p class="text_label-19 poppins-normal-black-20px">{{ text_Label1 }}</p>
                <div class="page-1"></div>
              </div>
              <div class="view-165">
                <div class="rectangle-33"></div>
                <div class="text_label-20 poppins-normal-black-20px">{{ text_Label2 }}</div>
              </div>
              <div class="text-203 poppins-normal-black-20px">{{ text203 }}</div>
              <div class="text_label-21 poppins-normal-black-20px">{{ text_Label3 }}</div>
            </div>
            <div class="text_label-22 poppins-semi-bold-black-20px">{{ text_Label4 }}</div>
            <div class="text_label-23 poppins-mediumitalic-medium-black-20px">{{ text_Label5 }}</div>
            <div class="flex-container-9901516 poppins-normal-black-20px">
              <div class="text-26">
                <span class="span-9 poppins-normal-black-20px">{{ spanText1 }}</span>
              </div>
              <div class="text-26">
                <span class="span-9 poppins-normal-black-20px">{{ spanText2 }}</span>
              </div>
            </div>
            <div class="text_label-24 poppins-semi-bold-black-20px">{{ text_Label6 }}</div>
            <div class="flex-container-9901518 poppins-normal-black-20px">
              <div class="text-26">
                <span class="span-9 poppins-normal-black-20px">{{ spanText3 }}</span>
              </div>
              <div class="text-26">
                <span class="span-9 poppins-normal-black-20px">{{ spanText4 }}</span>
              </div>
              <div class="text-26">
                <span class="span-9 poppins-normal-black-20px">{{ spanText5 }}</span>
              </div>
              <div class="text-26">
                <span class="span-9 poppins-normal-black-20px">{{ spanText6 }}</span>
              </div>
              <div class="text-26">
                <span class="span-9 poppins-normal-black-20px">{{ spanText7 }}</span>
              </div>
              <div class="text-26">
                <span class="span-9 poppins-normal-black-20px">{{ spanText8 }}</span>
              </div>
              <div class="text-26">
                <span class="span-9 poppins-normal-black-20px">{{ spanText9 }}</span>
              </div>
              <div class="text-26">
                <span class="span-9 poppins-normal-black-20px">{{ spanText10 }}</span>
              </div>
              <div class="text-26">
                <span class="span-9 poppins-normal-black-20px">{{ spanText11 }}</span>
              </div>
              <div class="text-26">
                <span class="span-9 poppins-normal-black-20px">{{ spanText12 }}</span>
              </div>
            </div>
            <div class="text_label-25 poppins-semi-bold-black-20px">{{ text_Label7 }}</div>
            <p class="x01-11 poppins-normal-black-20px">{{ x01 }}</p>
            <p class="x04-1-1 poppins-semi-bold-black-25px">{{ x041 }}</p>
          </div>
          <view622 />
        </div>
        <view642 :view67Props="view642Props.view67Props" />
        <div class="header-2-1">
          <div class="rectangle-207-2"></div>
          <div class="text-214 fontawesome5free-solid-normal-black-45px">{{ text214 }}</div>
          <router-link to="/course-page">
            <div class="text-215 fontawesome5free-solid-normal-black-24px">{{ text215 }}</div>
          </router-link>
        </div>
        <view682 />
      </div>
    </div>
  </div>
</template>

<script>
import View602 from "./View602";
import View622 from "./View622";
import View642 from "./View642";
import View682 from "./View682";
export default {
  name: "Screen5",
  components: {
    View602,
    View622,
    View642,
    View682,
  },
  props: [
    "text_Label1",
    "text_Label2",
    "text203",
    "text_Label3",
    "text_Label4",
    "text_Label5",
    "spanText1",
    "spanText2",
    "text_Label6",
    "spanText3",
    "spanText4",
    "spanText5",
    "spanText6",
    "spanText7",
    "spanText8",
    "spanText9",
    "spanText10",
    "spanText11",
    "spanText12",
    "text_Label7",
    "x01",
    "x041",
    "text214",
    "text215",
    "view642Props",
  ],
};
</script>

<style>
.u1089u1090u1088u1072u1085u1080u1094u1072-u1076u1086u1084u1072u1096u1082u1080 {
  align-items: flex-start;
  background-color: var(--white);
  display: flex;
  height: 1490px;
  overflow: hidden;
  width: 1920px;
}

.x-34 {
  height: 1483px;
  margin-top: 12px;
  position: relative;
  width: 1920px;
}

.view-161 {
  height: 1407px;
  left: 351px;
  position: absolute;
  top: 60px;
  width: 1506px;
}

.rectangle-26 {
  background-color: var(--cornflower);
  height: 1308px;
  left: -1px;
  opacity: 0.2;
  position: absolute;
  top: 100px;
  width: 1430px;
}

.view-162 {
  height: 1265px;
  left: 37px;
  position: absolute;
  top: 123px;
  width: 1373px;
}

.rectangle-27 {
  border: 2px solid;
  border-color: var(--black);
  height: 517px;
  left: -1px;
  opacity: 0.2;
  position: absolute;
  top: 749px;
  width: 1359px;
}

.view-163 {
  height: 458px;
  left: 68px;
  position: absolute;
  top: 774px;
  width: 1228px;
}

.view-164 {
  height: 363px;
  left: 0;
  position: absolute;
  top: 95px;
  width: 1226px;
}

.rectangle-32 {
  border: 2px solid;
  border-color: var(--black);
  height: 365px;
  left: -1px;
  opacity: 0.2;
  position: absolute;
  top: -1px;
  width: 1226px;
}

.text_label-19 {
  left: 408px;
  letter-spacing: 2.2px;
  line-height: normal;
  position: absolute;
  top: 272px;
}

.page-1 {
  background-image: url(https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/download---1454-.svg);
  background-size: 100% 100%;
  height: 190px;
  left: 525px;
  position: absolute;
  top: 43px;
  width: 200px;
}

.view-165 {
  height: 35px;
  left: 123px;
  position: absolute;
  top: 40px;
  width: 222px;
}

.rectangle-33 {
  background-color: var(--azure-radiance);
  border-radius: 10px;
  height: 35px;
  left: 0;
  opacity: 0.2;
  position: absolute;
  top: 0;
  width: 220px;
}

.text_label-20 {
  left: 21px;
  letter-spacing: 0.8px;
  line-height: normal;
  position: absolute;
  top: 2px;
}

.text-203 {
  left: 0;
  letter-spacing: 0.8px;
  line-height: normal;
  position: absolute;
  top: 41px;
}

.text_label-21 {
  left: 0;
  letter-spacing: 0.8px;
  line-height: normal;
  position: absolute;
  top: 0;
}

.text_label-22 {
  left: 11px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 709px;
}

.text_label-23 {
  left: 11px;
  letter-spacing: 1.6px;
  line-height: normal;
  position: absolute;
  top: 644px;
}

.flex-container-9901516 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 1.5px;
  height: 92px;
  left: 11px;
  position: absolute;
  top: 532px;
  width: 994px;
}

.text-26 {
  align-self: stretch;
  letter-spacing: 1.2px;
  line-height: normal;
  position: relative;
  text-align: justify;
}

.span-9 {
  letter-spacing: 0.24px;
}

.text_label-24 {
  left: 11px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 493px;
}

.flex-container-9901518 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 1.5px;
  height: 300px;
  left: 11px;
  position: absolute;
  top: 169px;
  width: 994px;
}

.text_label-25 {
  left: 11px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 128px;
}

.x01-11 {
  left: 11px;
  letter-spacing: 1.2px;
  line-height: normal;
  position: absolute;
  text-align: justify;
  top: 51px;
  width: 994px;
}

.x04-1-1 {
  left: 11px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 0;
}

.header-2-1 {
  height: 60px;
  left: calc(50% - 960px);
  position: absolute;
  top: 0;
  width: 1924px;
}

.rectangle-207-2 {
  background-color: var(--white);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: var(--black-10);
  height: 62px;
  left: calc(50% - 963px);
  position: absolute;
  top: -1px;
  width: 1922px;
}

.text-214 {
  left: 33px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: calc(50% - 26px);
  transform: rotate(180deg);
  white-space: nowrap;
}

.text-215 {
  cursor: pointer;
  left: 89px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 16px;
  white-space: nowrap;
}
</style>
